import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const EditProduct = () => {
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const API_URL = "https://backend.aktcorp.com/product"; // ✅ Your API endpoint here
  // const API_KEY = "your_api_key_here"; // ✅ Replace with your actual API Key

  const menus = ["AKT STEEL", "AKT TRADING", "AKT AUTOMOTIVE"];
  const submenus = {
    "AKT STEEL": ["STEEL STRUCTURE"],
    "AKT TRADING": ["SEALENTS", "Aircraft Maintenance (RTV)", "ADHESIVES", "ROOF COATINGS"],
    "AKT AUTOMOTIVE": ["AKT AUTOMOTIVE", "TIRE-REINFORCEMENT"],
  };

  // 📌 Fetch all matching products
  const fetchProducts = async () => {
    if (!category || !subcategory) {
      setError("⚠ Please select both Category and Subcategory.");
      setTimeout(() => setError(""), 3000);
      return;
    }

    setLoading(true);
    try {
      const encodedCategory = encodeURIComponent(category);
      const encodedSubcategory = encodeURIComponent(subcategory);

      const response = await fetch(`${API_URL}?category=${encodedCategory}&subcategory=${encodedSubcategory}`, {
        method: "GET",
        // headers: { "x-api-key": API_KEY },
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();

      // ✅ Frontend filter just in case backend doesn't work
      const filteredProducts = (result.data || []).filter(
        (item) => item.category === category && item.subcategory === subcategory
      );

      if (filteredProducts.length === 0) {
        throw new Error("No products found.");
      }

      // ✅ Navigate to listing page and pass products in state
      navigate("/delete-listing-daynamic", { state: { products: filteredProducts } });
    } catch (error) {
      console.error("Error fetching products:", error);
      setError("⚠ No products found. Please try again.");
      setTimeout(() => setError(""), 3000);
    }
    setLoading(false);
  };

  return (
    <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-lg p-6 space-y-6">
      <motion.h2
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-3xl font-bold text-gray-900 bg-clip-text text-center mb-4 text-transparent bg-gradient-to-r from-blue-500 to-purple-500"
      >
        Update Product
      </motion.h2>

      {error && <p className="text-red-500 text-center font-semibold">{error}</p>}

      <label className="block text-lg font-semibold">Choose Category:</label>
      <select
        className="w-full p-2 border rounded-md"
        onChange={(e) => {
          setCategory(e.target.value);
          setSubcategory(""); // ✅ Reset subcategory when category changes
        }}
        value={category}
      >
        <option value="">Choose a Category</option>
        {menus.map((cat) => (
          <option key={cat} value={cat}>
            {cat}
          </option>
        ))}
      </select>

      <label className="block text-lg font-semibold">Choose Subcategory:</label>
      <select
        className="w-full p-2 border rounded-md"
        onChange={(e) => setSubcategory(e.target.value)}
        value={subcategory}
        disabled={!category}
      >
        <option value="">Choose a Subcategory</option>
        {category &&
          submenus[category]?.map((subcat) => (
            <option key={subcat} value={subcat}>
              {subcat}
            </option>
          ))}
      </select>

      <button
        onClick={fetchProducts}
        className="mt-4 w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600"
      >
        {loading ? "Loading..." : "Get Data"}
      </button>
    </div>
  );
};

export default EditProduct;
